<template>
    <div>
        <v-progress-circular indeterminate v-if="status === statuses.pending || offer"/>
        <div class="presentation" v-if="status === statuses.loaded">
            <v-carousel
                    class="project-carousel"
                    v-model="carousel">
                <v-carousel-item
                        :key="i"
                        v-for="(item,i) in visualisation">
                    <img
                            :src="item"
                            alt=""
                            style="width:100%;height:auto !important;"/>
                </v-carousel-item>
            </v-carousel>
        </div>
        <v-alert
            color="info"
            outlined
            border="bottom"
            dismissible>
            {{ $t('steps.presentation.message') }}
        </v-alert>
        <v-btn @click="$emit('complete')" color="primary">{{ $t('base.next') }}</v-btn>
        <v-btn @click="$emit('abort')" text>{{ $t('steps.back_to_surface') }}</v-btn>
    </div>
</template>

<script>
    import projectStatus from "@/helpers/projectStatus";

    export default {
        props: ['preparing', 'offer'],
        computed: {
            status() {
                return this.$store.state.configurator.projects.status
            },
            statuses() {
                return projectStatus
            },
            visualisation() {
                let vis = []
                this.$store.state.configurator.projects.items.map(terrace => {
                    for (var collection in terrace.projects) {
                        if(collection !== 'slats') {
                            vis.push(terrace.projects[collection])
                        }
                    }
                    vis.push(terrace.projects['slats'])
                })
                return vis
            },
            catalog() {
                return this.$store.state.configurator.catalog
            }
        },
        data() {
            return {
                carousel: 0
            }
        }
    }
</script>

<style>
    .presentation {
        margin-top: 10px;
        margin-bottom: 20px;
    }

    .project-carousel,
    .project-carousel .v-window__container,
    .project-carousel .v-image__image--cover,
    .project-carousel .v-carousel__item {
        height: 100% !important;
        max-width: 800px;
    }
</style>
